import React from 'react';
import { motion } from 'framer-motion';
interface PageHeroProps {
  title: string;
  image: string;
  alt: string;
}
export function PageHero({
  title,
  image,
  alt
}: PageHeroProps) {
  return <div className="relative h-[40vh] min-h-[300px] flex items-center justify-center overflow-hidden" data-id="element-116">
      <div className="absolute inset-0 z-0" data-id="element-117">
        <img src={image} alt={alt} className="w-full h-full object-cover object-center" data-id="element-118" />
        <div className="absolute inset-0 bg-brand-hunter/70 mix-blend-multiply" data-id="element-119"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-brand-charcoal/90 via-brand-charcoal/40 to-transparent" data-id="element-120"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full text-center" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-122">
          <div className="flex items-center justify-center space-x-2 mb-4" data-id="element-123">
            <div className="h-px w-8 bg-brand-leather" data-id="element-124"></div>
            <span className="text-brand-bone uppercase tracking-widest text-xs font-semibold" data-id="element-125">
              Kjergaard Sports
            </span>
            <div className="h-px w-8 bg-brand-leather" data-id="element-126"></div>
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-brand-offwhite leading-tight" data-id="element-127">
            {title}
          </h1>
        </motion.div>
      </div>
    </div>;
}